import { LabelSmall, ParagraphXSmall } from "baseui/typography"
import { CreateRelationsCommand, DeleteRelationsCommand, useCreateRelationMutation, useDeleteRelationMutation, useGetRelationsOutByIdQuery } from "../../../services/objects"
import { ListPanelWrapper } from "../../components/ListPaneWrapper"
import { FormattedMessage, useIntl } from "react-intl"
import { IBaseCounter } from "./types"
import { ObjectNavigatorModal } from "../../../features/ObjectSelector/Modal"
import { useState } from "react"
import { Button } from "baseui/button"
import { IAutomationObject } from "../../types"
import { PlantSchemas } from "../../Plants/types"
import { schema as schemaBuilding } from '../../Plants/Buildings/P_Building'
import { schema as schemaCampus } from '../../Collections/SpaceCollections/Campus'
import { useReportMutationState } from '../../../hooks/useReportMutationState'
import { VscAdd, VscRemove, VscTrash } from "react-icons/vsc"
import { EmptyState } from "../../../components/EmptyState"
import { useStyletron } from "baseui"

export const RelatedPlants = (props: IBaseCounter) => {
    const [css,] = useStyletron();
    const intl = useIntl();
    const { data, isLoading, isSuccess, error, refetch } = useGetRelationsOutByIdQuery({ objectId: props.id, resourceGroupId: props.resourceGroupId, type: 'Measures' })

    const [deleteRelation, deleteRelationResult] = useDeleteRelationMutation();
    useReportMutationState(deleteRelationResult, () => { setTimeout(() => { refetch(); }, 2000) });

    const handleDeleteRelation = (selected: IAutomationObject) => {

        const cmd2: DeleteRelationsCommand = {
            fromObjectId: props.id,
            resourceGroupId: props.resourceGroupId,
            toObjectId: selected.id,
            type: 'Measures'
        }
        deleteRelation(cmd2)
    };

    const handleNewLinkAdded = () => {
        setTimeout(() => { refetch(); }, 2000);
    }

    return (
        <>

            <ParagraphXSmall marginBottom={0}><FormattedMessage id='counter.measuersplants' defaultMessage={'This energy meter measures the following system(s)'}></FormattedMessage></ParagraphXSmall>
            <div className={css({ position: 'relative' })}>
                {data && data.length === 0 &&
                    <EmptyState header={intl.formatMessage({id: 'counter.norelation', defaultMessage: "No relation"})} message={intl.formatMessage({id: 'counter.norelationdescr', defaultMessage: "No related plants"})}></EmptyState>
                }
                {data && data.map((target) =>
                    <><ListPanelWrapper {...target} endEnhancer={<Button onClick={() => handleDeleteRelation(target)} size="compact" kind="tertiary" shape="circle"><VscTrash></VscTrash></Button>}></ListPanelWrapper></>)
                }
                <div className={css({ position: 'absolute', bottom: "-20px", right: "-20px" })}>
                    <AddPlantLink {...props} onAdded={handleNewLinkAdded}></AddPlantLink>
                </div>
            </div>
        </>
    )
}

const AddPlantLink = (props) => {
    const [isOpen, setIsOpen] = useState(false);

    const [addRelation, addRelationResult] = useCreateRelationMutation();
    useReportMutationState(addRelationResult, () => { props.onAdded(); });

    const handleSelect = (selected: IAutomationObject) => {
        if (PlantSchemas.includes(selected.schema)) {
            const cmd2: CreateRelationsCommand = {
                fromObjectId: props.id,
                resourceGroupId: props.resourceGroupId,
                toObjectId: selected.id,
                type: 'Measures'
            }
            addRelation(cmd2)
        }
        else
            alert('Object type not supported');
    };

    const validSelections = [schemaBuilding, schemaCampus, ...PlantSchemas]
    const handleFilter = (app: IAutomationObject) => {
        return app.resourceGroupId === props.resourceGroupId && (validSelections.includes(app.schema))
    }

    return (
        <>

            <Button shape='circle' kind='secondary' onClick={() => setIsOpen(true)}><VscAdd /></Button>
            <ObjectNavigatorModal isOpen={isOpen} setIsOpen={(v) => setIsOpen(v)} currentSelectedParent={props}
                onSelected={handleSelect}
                filter={handleFilter}
                title={<FormattedMessage id='counter.selectplant' defaultMessage={'Select Plant'}></FormattedMessage>}
            ></ObjectNavigatorModal>
        </>)
}